const app_env = process.env.NODE_ENV
// can't be set when developing for some reason
const APP_ENV = app_env ? app_env.trim().toLowerCase() : 'dev'


// NODE_ENV='development'
export const is_dev = 'development' == APP_ENV
